export const PLANS = {
  FREE: 'free',
  PRO: 'pro',
};
